import React, { useState } from "react";
import { useEffect } from "react";
import styles from "../styles/scroll.module.css";

const Scroll = () => {
  const [isVisble, setisVisble] = useState(false);
  const goToBtn = () => {
    window.scrollTo({ top: 0, right: 0, behavior: "smooth" });
  };
  const listenrScroll = () => {
    let hightohid = 250;
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;
    if (winScroll > hightohid) {
      setisVisble(true);
    } else {
      setisVisble(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", listenrScroll);
    return () => window.removeEventListener("scroll", listenrScroll);
  }, []);

  return (
    <>
      {isVisble && (
        <div className={styles.topbtn} onClick={goToBtn}>
          <h1 className={styles.icon}>⬆️</h1>

           <button
      id="scrollToTopBtn"
      title="Go to top"
      class="fixed bottom-6 right-6 z-50 px-2 py-1 bg-orange-600 text-white rounded-full shadow-lg hover:bg-orange-700 transition-opacity hidden"
    >
      <i class="fas fa-chevron-up"></i>
    </button>
        </div>
      )}
    </>
  );
};

export default Scroll;
